import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/ui/Modal";
import { Button } from "../../../components/ui/Button";
import api from "../../../services/api";
import { extractErrorMessage } from "../utils";

export function RemoveUserModal({ open, user, onClose, onRemoved }) {
  const { t } = useTranslation();
  const [removing, setRemoving] = useState(false);
  const [error, setError] = useState(null);

  function handleClose() {
    setRemoving(false);
    setError(null);
    onClose?.();
  }

  async function handleConfirm() {
    setRemoving(true);
    setError(null);
    try {
      await api.delete(`/users/${user._id}`);
      onRemoved?.(user._id);
      handleClose();
    } catch (e) {
      setError(extractErrorMessage(e, t("users.remove_user_error_generic")));
    } finally {
      setRemoving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={t("users.remove_user_modal_title")}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            {t("common.close")}
          </Button>
          <Button variant="danger" onClick={handleConfirm} loading={removing}>
            {t("users.remove_user_confirm_button")}
          </Button>
        </>
      }
    >
      <p className="text-[12.5px] text-slate-600">
        {t("users.remove_user_confirm_text", {
          name: `${user?.firstName || ""} ${user?.lastName || ""}`.trim(),
        })}
      </p>
      {error && <p className="text-[12px] text-rose-600">{error}</p>}
    </Modal>
  );
}

export default RemoveUserModal;
